import { createAction, props } from '@ngrx/store';
import { Program } from './program-autocomplete.reducer';
import { ProgramAvailabilityTagApiModel } from '@cxb/editor-stb-api';

const featureKey = 'cxbProgramAutocomplete';

export const programAutocompleteInstanceInit = createAction(`${featureKey} Initialize instance`, props<{ instanceId: string }>());
export const programAutocompleteInstanceClear = createAction(`${featureKey} Clear instance`, props<{ instanceId: string }>());

export const programAutocompleteById = createAction(
  `${featureKey} Load program by id`,
  props<{ id: number; availabilityTag: ProgramAvailabilityTagApiModel; instanceId: string }>()
);
export const programAutocompleteQuery = createAction(
  `${featureKey} Load programs by query`,
  props<{ query: string; seriesOnly: boolean; availabilityTag: ProgramAvailabilityTagApiModel; instanceId: string }>()
);

export const programAutocompleteByIdSuccess = createAction(
  `${featureKey} Loaded program by id`,
  props<{ program: Program; instanceId: string; isAvailable: boolean }>()
);
export const programAutocompleteQuerySuccess = createAction(
  `${featureKey} Loaded programs by query`,
  props<{ programs: Program[]; instanceId: string }>()
);

export const programAutocompleteByIdFail = createAction(
  `${featureKey} Failed to load program`,
  props<{ errorMessage: string; instanceId: string }>()
);
export const programAutocompleteQueryFail = createAction(
  `${featureKey} Failed to load programs`,
  props<{ errorMessage: string; instanceId: string }>()
);
